import Text from "../../components/Text";
import { useState } from "react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import TextContainer from "../../components/TextContainer";
import SessionScreen from "../../components/SessionScreen";
import Spinner from "../../components/Spinner";
import { post } from "aws-amplify/api";
import { useTheme } from "../../scripts/functions/ThemeProvider";
import { AccessValidations } from "../../scripts/functions/AccessValidations";
import { loadFromStorage, useSaveToStorage } from "../../utils";
const RequestAccess = () => {
    const persisted = loadFromStorage('SESSION_DATA') || {};
    const {theme, isDark} = useTheme();
    const [generalError, setGeneralError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isRequestSent, setIsRequestSent] = useState(false);

    const {mail, name, formError, isValid, setMail, setName, setFormError, validateFields} = AccessValidations(persisted.mail, "", true, persisted.name);

    useSaveToStorage('SESSION_DATA', {mail, name});
    const navigate = useNavigate();

    const access = async (e) => {
        e.preventDefault()

        if (isRequestSent) return;

        setGeneralError('');
        
        const {errors, isValid} = validateFields(mail, name);
        setFormError(errors);
        if(!isValid) {
            // console.log("Entered");
            return;
        }

        setIsLoading(true);

        const body = {name, mail};

        try {
            const resp = post({apiName: 'Api', path: '/accessreq/accessRequest', options: {body}});
            await resp.response;
            setIsRequestSent(true); //Mark request as sent

            setFormError('Solicitud enviada! Un administrador la revisará en breve')
        } catch(e) {
            console.error("Error al mandar la solicitud: ", e);
            setFormError('Hubo un error al enviar la solicitud. Intenta más tarde');
            setIsRequestSent(false);
        } finally {
            setIsLoading(false);
        }
    }

    const isFormDisabled = isLoading || isRequestSent;

    const buttonText = isLoading ? "Enviando..." : isRequestSent ? "Acceso solicitado" : "Solicitar acceso";

    return(
        <SessionScreen theme={theme} isDark={isDark}>
            <form onSubmit={access}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start', width: '100%', gap: 4, position: 'relative'}}>
                    <Text color={theme.Black} size={15} weight={"medium"}>Correo</Text>
                    <TextContainer disabled={isFormDisabled} autoComplete="username" style={{width: '100%', height: 36}} value={mail} theme={theme} placeHolder="something@domain.com.mx" onChange={(value) => setMail(value)} />
                    {formError.mail && <Text color="red" size={12} style={{ top: 65, position: 'absolute' }}>{formError.mail}</Text>}
                </div>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start', width: '100%', gap: 4, position: 'relative', marginTop: '30px'}}>
                    <Text color={theme.Black} size={15} weight={"medium"}>Nombre</Text>
                    <TextContainer disabled={isFormDisabled} style={{width: '100%', height: 36}} value={name} theme={theme} placeHolder="" onChange={(value) => setName(value)} />
                    {formError.name && <Text color="red" size={12} style={{ top: 65, position: 'absolute' }}>{formError.name}</Text>}
                    {generalError && !formError.password && <Text color="red" size={12} style={{top: 65, position: 'absolute' }}>{generalError}</Text>}
                </div>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start', width: '100%', gap: 4, marginTop: '30px'}}>
                    <Button disableElevation type="submit" disabled={isFormDisabled || !isValid} variant="contained" sx={{width: '100%', height: 52, border: 1, borderColor: theme.Coco, backgroundColor: (isValid || !isRequestSent) ? theme.Black : theme.Ey, color: (isValid || !isRequestSent) ? theme.White : theme.Audi, fontWeight: 'medium', fontSize: 15, textTransform: 'none', '&.Mui-disabled': {backgroundColor: isDark ? theme.Audi : theme.Ey}}}>{buttonText}</Button>
                </div>
            </form>
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <Text color={theme.SEVENB} size={15} weight={"medium"}>Cuando tu solicitud sea aprobada, recibirás un correo para poder acceder al sistema.</Text>
            </div>
            <div style={{display: 'flex', flexDirection: 'column', position: 'relative'}}>
                {
                    isLoading && (
                        <div style={{position: 'absolute', top:0, left:0, right:0, bottom:0, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <Spinner theme={theme}/> 
                        </div>
                    )
                }
            </div>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start', width: '100%', gap: 8, marginTop: 'clamp(24px, 10dvh, 128px)'}}>
                <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} color={theme.Magenta} onClick={() => navigate('/login')} size={15}>Iniciar sesión</Text>
            </div>
        </SessionScreen>
    )
}

export default RequestAccess;